// src/components/MainLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "../styles/MainLayout.css";

const MainLayout: React.FC = () => {
    return (
        <div className="main-layout">
            {/* Navigation Bar */}
            <NavBar />

            {/* Main Content Area */}
            <main className="main-content">
                {/* Renders the child routes */}
                <Outlet />
            </main>

            <Footer />
        </div>
    );
};

export default MainLayout;
